var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.60605 15.1196C2.27272 15.1196 2 14.8469 2 14.5136V2.54404C2 2.21071 2.27272 1.93799 2.60605 1.93799C2.93938 1.93799 3.2121 2.21071 3.2121 2.54404V14.5136C3.1818 14.8469 2.93938 15.1196 2.60605 15.1196Z",
    fill: "#292D32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.87875 10.7864C3.87876 10.7864 3.03029 10.4531 2.21212 9.72583C2.09091 9.60462 2 9.4531 2 9.27129V2.3926C2 2.15018 2.15151 1.93806 2.36363 1.84715C2.57575 1.75625 2.81817 1.78655 2.99999 1.93806C3.60604 2.4532 4.18179 2.69563 4.87875 2.69563C5.78782 2.69563 6.75751 2.27139 7.75749 1.81685C8.84838 1.33201 9.93928 0.847168 11.1211 0.847168C12.1211 0.847168 12.9695 1.1805 13.7877 1.90776C13.9089 2.02897 13.9998 2.18048 13.9998 2.3623V9.24098C13.9998 9.48341 13.8483 9.69552 13.6362 9.78643C13.4241 9.87734 13.1817 9.84704 12.9998 9.69552C12.3938 9.18038 11.818 8.93796 11.1211 8.93796C10.212 8.93796 9.24232 9.36219 8.24233 9.81673C7.15144 10.2713 6.03024 10.7561 4.87875 10.7864ZM3.1818 8.99856C3.69694 9.3925 4.24239 9.60461 4.87875 9.60461C5.78782 9.60461 6.75751 9.18038 7.75749 8.72584C8.84838 8.241 9.93928 7.75616 11.1211 7.75616C11.7271 7.75616 12.2726 7.87737 12.818 8.15009V2.66532C12.3029 2.27139 11.7574 2.05927 11.1211 2.05927C10.212 2.05927 9.24232 2.48351 8.24233 2.93805C7.15144 3.42289 6.06055 3.90773 4.87875 3.90773C4.27269 3.90773 3.72725 3.78652 3.1818 3.5138V8.99856Z",
    fill: "#292D32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNational);
export default __webpack_public_path__ + "static/media/national.14662c30d7df7d07b5bebcef6f8fa719.svg";
export { ForwardRef as ReactComponent };